import {
  FETCH_SESIONES_REQUEST,
  FETCH_SESIONES_SUCCESS,
  FETCH_SESIONES_FAILURE,
} from "../actions/sesiones/types";

const initialState = { data: [], loading: false, error: null };

const sesionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SESIONES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SESIONES_SUCCESS: {
      const payload = action.payload;
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.items)
        ? payload.items
        : [];
      return { ...state, loading: false, data: items, error: null };
    }
    case FETCH_SESIONES_FAILURE:
      return { ...state, loading: false, error: action.payload?.error };
    default:
      return state;
  }
};

export default sesionesReducer;
